const BASE_URL: string = process.env.REACT_APP_API_KEY || '';

export const FIND_MANY_DELIVERY_FEE = BASE_URL + '/merchant/delivery-fee/find-many';
export const CREATE_DELIVERY_FEE = BASE_URL + '/merchant/delivery-fee/create';
export const UPDATE_DELIVERY_FEE = BASE_URL + '/merchant/delivery-fee/update/';
export const DELETE_DELIVERY_FEE = BASE_URL + '/merchant/delivery-fee/';